module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.3ed9575d.ttf";